import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(({ theme }) => ({
  height: "100%",
  padding: 0,
  position: "relative",
  display: "flex",
  flexDirection: "column",

  [theme.breakpoints.up("md")]: {
    padding: "24px 32px",
  },
}));
